'use strict';

const MODAL_HAS_BEEN_CLOSED = 'fraguaOneTimeModalClosed';
const pageDesignerUtils = require('../util/pageDesigner');

/**
 * Handles the hiding of the modal by setting a flag in local storage.
 * This flag indicates that the modal has been closed by the user.
 */
const handleHideModal = () => {
    localStorage.setItem(MODAL_HAS_BEEN_CLOSED, 'true');
}

/**
 * Handles the display of the modal backdrop.
 * This function ensures that the modal backdrop is visible
 */
const handleShowModal = () => {
    // Shows the backdrop, usually if it was removed for the stlye of other page
    $('.modal-backdrop').css('display', 'block');
}

/**
 * Checks if the one-time modal should be shown.
 * 
 * This function determines whether the one-time modal has been closed before
 * by checking the local storage for a specific item. If the item is not found,
 * it indicates that the modal has not been closed yet.
 * 
 * @returns {boolean} Returns true if the modal has not been closed before, otherwise `false`.
 */
const shouldShowOneTimeModal = () => {
    return !localStorage.getItem(MODAL_HAS_BEEN_CLOSED) && !pageDesignerUtils.isPageDesignerEditMode();
}

/**
 * Initializes the one-time modal functionality.
 * 
 * This function checks if the one-time modal should be displayed based on the presence
 * of the content slot and the local storage value.
 * Then:
 * - For mobile devices, it triggers the `openBottomSheetRequest` event to open a bottom sheet.
 * - For desktop devices, it shows a Bootstrap modal.
 * 
 * The function also sets up event listeners to handle the modal hide events.
 */
const initOneTimeModal = () => {
    const slotContainer = $('.one-time-modal .html-slot-container');

    if (slotContainer.length && shouldShowOneTimeModal()) {
        const isMobile = $('.ua-mobile').length > 0;

        if (isMobile) {
            const bottomSheetSelector = '#oneTimeModal';
            $(document).trigger('openBottomSheetRequest', { targetId: bottomSheetSelector });
            $(bottomSheetSelector).find('.bottom-sheet-content').on('bottomSheetClosed', handleHideModal);
        }
        else {
            const desktopModal = $('#modaloneTimeModal');
            desktopModal.modal('show');
            desktopModal.on('hidden.bs.modal', handleHideModal);
            desktopModal.on('shown.bs.modal', handleShowModal);
        }
    }
}

module.exports = {
    initOneTimeModal
};